import colors from 'src/integration/styles/colors';
import resetCSS from 'src/integration/styles/reset';
import breakpoints from 'src/integration/styles/breakpoints';
import { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  ${resetCSS}
  
  
  ${() => css`
    html {
      scroll-behavior: smooth;
      font-size: 100%;

      @-moz-document url-prefix() {
        scroll-behavior: auto;
      }

      ${breakpoints.desktopLarge4K`
        font-size: 150%;
      `}
    }

    body {
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-style: normal;
      background-color: ${colors.grey5}
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: "Quicksand", sans-serif;
        font-weight: 300;
        font-style: normal;
    }

    all: initial;
    height: 100%;
    width: 100%;
    font-weight: normal;
  `}
`;

export default GlobalStyle;
